import { render, staticRenderFns } from "./FeatureTagsAdminSort.vue?vue&type=template&id=193dc3f4&scoped=true&lang=pug"
import script from "./FeatureTagsAdminSort.vue?vue&type=script&lang=js"
export * from "./FeatureTagsAdminSort.vue?vue&type=script&lang=js"
import style0 from "./FeatureTagsAdminSort.vue?vue&type=style&index=0&id=193dc3f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193dc3f4",
  null
  
)

export default component.exports